/*import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import OurProduct from "../Home/OurProduct";
import { getProducts } from "../../Services/ProductService";

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({});
1
  const fetchProducts = async (filters = {}) => {
    const ac = new AbortController();
    setLoading(true);
    setError(null);

    try {
      const params = {
        signal: ac.signal,
        categoryIds: [1,6]
      };

      // Check if custom products filter is selected
      if (filters.isCustomProduct && filters.isCustomProduct.length > 0) {
        // For custom products, we need to filter on the frontend or modify the API call
        // Since the API might not support isCustomProduct directly, we'll fetch all and filter
        const response = await getProducts(params);
        if (!response.status) {
          setError(response.message);
          return;
        }
        const allProducts = response.products || [];
        const customProducts = allProducts.filter(product => product.isCustomProduct === true);
        setProducts(customProducts);
      } else {
        // Convert filters to attributeValue array format for regular filters
        const attributeValues = [];
        Object.keys(filters).forEach((attributeName) => {
          if (attributeName !== 'isCustomProduct' && filters[attributeName]) {
            filters[attributeName].forEach((filter) => {
              attributeValues.push(filter.id);
            });
          }
        });

        // Pass attributeValue as array if there are selected filters
        if (attributeValues.length > 0) {
          params.attributeValue = attributeValues;
        }

        const response = await getProducts(params);
        if (!response.status) {
          setError(response.message);
          return;
        }
        setProducts(response.products || []);
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        setError(err.message || "Failed to load products");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (filters) => {
    setSelectedFilters(filters);
    fetchProducts(filters);
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
      <>
          <div className="shop-page">
              <div className="container">
                  <div className="row">
                      <div className="col-xl-3">
                          <Sidebar onFilterChange={handleFilterChange} />

                          // <div className="shop-filter d-xl-none">
                          //    <div className={'d-flex align-items-center flex-wrap'}>
                           //       <div className="form-check custom-radio mr_22">
                           //           <input className="form-check-input" type="radio" id="yes" checked />
                           //           <label className="form-check-label" htmlFor="yes">Show All Products</label>
                             //     </div>
                               //   <div className="form-check custom-radio">
                                 //     <input className="form-check-input" type="radio" id="yes" />
                                   //   <label className="form-check-label" htmlFor="yes">Show In-Stock Products</label>
                                  //</div>
                             // </div>
                        //  </div> 
                      </div>

                      <div className={'col-xl-9'}>
                        <div className="row g-4">
                            <div className="col-12">
                                <div className="section-title pt_42">
                                    <h5>Our Products</h5>
                                    <p>Select Customise, and convert with precision.</p>
                                </div>
                            </div>
                            
                            {loading ? (
                              <div className="col-12 text-center py-5">
                                <p>Loading products...</p>
                              </div>
                            ) : error ? (
                              <div className="col-12 text-center py-5">
                                <p className="text-danger">{error}</p>
                              </div>
                            ) : products.length === 0 ? (
                              <div className="col-12 text-center py-5">
                                <p>No products found.</p>
                              </div>
                            ) : (
                              products.map((product, index) => (
                                <div key={product.id || product._id || index} className="col-md-4 col-sm-6 col-6">
                                  <OurProduct product={product} />
                                </div>
                              ))
                            )}
                        </div>
                      </div>
                  </div>
              </div>
          </div>

      </>
  );
};

export default Shop;*/








import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import OurProduct from "../Home/OurProduct";
import { getProducts } from "../../Services/ProductService";

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({});

  const fetchProducts = async (filters = {}) => {
    const ac = new AbortController();
    setLoading(true);
    setError(null);

    try {
      const params = {
        signal: ac.signal,
        categoryIds: [1, 6, 9],
      };

      // ✅ Custom product filter
      if (filters.isCustomProduct && filters.isCustomProduct.length > 0) {
        const response = await getProducts(params);

        if (!response.status) {
          setError(response.message);
          return;
        }

        const allProducts = response.products || [];
        const customProducts = allProducts.filter(
          (product) => product.isCustomProduct === true
        );

        setProducts(customProducts);
      } else {
        // ✅ Attribute filters
        const attributeValues = [];

        Object.keys(filters).forEach((attributeName) => {
          if (
            attributeName !== "isCustomProduct" &&
            filters[attributeName]
          ) {
            filters[attributeName].forEach((filter) => {
              attributeValues.push(filter.id);
            });
          }
        });

        if (attributeValues.length > 0) {
          params.attributeValue = attributeValues;
        }

        const response = await getProducts(params);

        if (!response.status) {
          setError(response.message);
          return;
        }

        setProducts(response.products || []);
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        setError(err.message || "Failed to load products");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (filters) => {
    setSelectedFilters(filters);
    fetchProducts(filters);
  };

  useEffect(() => {
    fetchProducts(selectedFilters);

    const handleLocationFetched = () => {
      fetchProducts(selectedFilters);
    };

    window.addEventListener("locationFetched", handleLocationFetched);
    return () => window.removeEventListener("locationFetched", handleLocationFetched);
  }, [selectedFilters]);

  return (
    <div className="shop-page">
      <div className="container">
        <div className="row">
          {/* LEFT SIDEBAR */}
          <div className="col-xl-3">
            <Sidebar onFilterChange={handleFilterChange} />
          </div>

          {/* RIGHT PRODUCT LIST */}
          <div className="col-xl-9">
            <div className="row g-4">
              <div className="col-12">
                <div className="section-title pt_42">
                  <h5>Our Products</h5>
                  <p>Select Customise, and convert with precision.</p>
                </div>
              </div>

              {loading ? (
                <div className="col-12 text-center py-5">
                  <p>Loading products...</p>
                </div>
              ) : error ? (
                // ✅ ERROR MESSAGE AS BUTTON
                <div className="col-12 text-center py-5">
                  <button
                    onClick={error.toLowerCase().includes("location") ? () => window.dispatchEvent(new CustomEvent("openLocationModal")) : undefined}
                    style={{
                      backgroundColor: "#A37C4D",
                      color: "#fff",
                      border: "none",
                      padding: "10px 24px",
                      borderRadius: "6px",
                      fontSize: "14px",
                      cursor: error.toLowerCase().includes("location") ? "pointer" : "default",
                    }}
                  >
                    {error}
                  </button>
                </div>
              ) : products.length === 0 ? (
                <div className="col-12 text-center py-5">
                  <p>No products found.</p>
                </div>
              ) : (
                products.map((product, index) => (
                  <div
                    key={product.id || product._id || index}
                    className="col-md-4 col-sm-6 col-6"
                  >
                    <OurProduct product={product} />
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shop;

